import { Container, Divider, List, Stack, Text, Title } from '@mantine/core'
import { Seo } from '../components/Seo'

export default function PartnerTermsPage() {
  return (
    <>
      <Seo
        title="Партнёрская программа — условия"
        description="Правила партнёрской программы: промокоды только на первое пополнение, базовый процент с последующих оплат, обязанности и ограничения."
        canonical="/legal/partner-terms"
      />
      <Container size="md" py="xl">
        <Stack gap="lg">
          <Title order={2}>Партнёрская программа</Title>
          <Text c="dimmed">Последнее обновление: {new Date().toLocaleDateString('ru-RU')}</Text>

          <Divider />

          <Stack gap="sm">
            <Title order={4}>1. Общие положения</Title>
            <Text size="sm">
              Эти условия регулируют участие в партнёрской программе. Используя промокоды или реферальные ссылки, вы
              подтверждаете согласие с условиями и обязуетесь их соблюдать.
            </Text>
          </Stack>

          <Stack gap="sm">
            <Title order={4}>2. Механика начислений</Title>
            <List size="sm" spacing="xs">
              <List.Item>Промокоды партнёра действуют только на первое пополнение пользователя.</List.Item>
              <List.Item>Все последующие пополнения привязанного пользователя приносят партнёру базовый процент профиля.</List.Item>
              <List.Item>Самореферал запрещён (если не указано иное в профиле); такие начисления не производятся.</List.Item>
              <List.Item>Начисления могут иметь холд и подтверждаются после его истечения.</List.Item>
            </List>
          </Stack>

          <Stack gap="sm">
            <Title order={4}>3. Промокоды и ссылки</Title>
            <List size="sm" spacing="xs">
              <List.Item>Запрещено передавать промокоды/ссылки через спам, вводящую в заблуждение рекламу или с нарушением закона.</List.Item>
              <List.Item>Код может быть одноразовым для пользователя; повторное использование блокируется.</List.Item>
              <List.Item>Смена партнёра при активной привязке не допускается, если иное не согласовано с менеджером.</List.Item>
            </List>
          </Stack>

          <Stack gap="sm">
            <Title order={4}>4. Ответственность</Title>
            <List size="sm" spacing="xs">
              <List.Item>За нарушение условий, мошенничество или злоупотребления аккаунт партнёра может быть отключён.</List.Item>
              <List.Item>Администрация вправе изменять условия программы; актуальная версия публикуется на этой странице.</List.Item>
            </List>
          </Stack>

          <Stack gap="sm">
            <Title order={4}>5. Выплаты</Title>
            <Text size="sm">
              Выплаты осуществляются вручную через менеджера при достижении минимального порога, указанного в вашем профиле.
              Вывод на расчетный счет или через самозанятость.
              Статус начислений (hold/к выплате/выплачено) отражён в кабинете партнёра.
            </Text>
          </Stack>
        </Stack>
      </Container>
    </>
  )
}
